export default {
  namespaced  : true,
  state       : {
    id            : null,
    start         : null,
    end           : null,
    current       : null,
    zero_end      : null,
    zero_current  : null
  },

  mutations   : {
    setCharacterLevel(state, data){
      state.id            = data.id;
      state.start         = data.start;
      state.end           = data.end;
      state.current       = data.current;
      state.zero_end      = data.zero_end;
      state.zero_current  = data.zero_current;
    },

    resetStore(state){
      state.id            = null;
      state.start         = null;
      state.end           = null;
      state.current       = null;
      state.zero_end      = null;
      state.zero_current  = null;
    }
  },

  actions : {
    updateCharacterLevel(context, payload){
      context.commit('setCharacterLevel', payload.data);
    },

    resetStore(context){
      context.commit('resetStore');
    }
  }
}